<template>
  <div>
    <v-text-field
      :suffix="getparabirimi()"
      :etiket="$t('Commission-Amount-v2')"
      v-model="val"
    ></v-text-field>
  </div>
</template>

<script>
import tool from "../tools";
import helpers from "@/components/app/customcomp/helpers.js";
export default {
  props: {
    value: {},
    kurTarihi: {},
    paraTip: {
      default: "TL",
    },
  },
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  data() {
    return { kurList: [] };
  },
  watch: {
    paraTip() {
      if (this.kurList.length == 0) {
        this.gunlukKurlariCek();
      } else {
        this.getKur();
      }
    },
  },
  methods: {
    getparabirimi() {
      return helpers.getparabirimi();
    },
    getKur() {
      var kayitvarmi = this.kurList
        .map(function (e) {
          return e.paraBirimi;
        })
        .indexOf(this.paraTip);

      if (kayitvarmi != -1) {
        this.val = this.kurList[kayitvarmi].kur;
      } else {
        if (this.paraTip != "TL" && this.paraTip != "YTL") {
          this.val = 0;
        } else {
          this.val = 1;
        }
      }
    },
    gunlukKurlariCek() {
      var tarih = this.kurTarihi;
      if (this.kurtarihi == null) {
        tarih = tool.Now_yyyy_MM_dd();
      } else {
      }
      tool
        .http_post(this, "KurAra", {
          tarih: tarih,
        })
        .then(
          (response) => {
            this.kurList = response.body;
            this.getKur();
          },
          (response) => {}
        );
    },
  },
};
</script>